module.exports = __webpack_public_path__ + "img/rightbicep-mesomorph-male.f1d3755b.svg";